import type { NavigateFunction } from 'react-router-dom';
import type { TrainerSection } from './TrainerLeftRail';
import { CHAT_NAV_ENABLED } from '../../../lib/chatNavEnabled';

/** Persist hub section before navigating away from drill-down routes. */
export function persistTrainerDashboardSection(section: TrainerSection): void {
  const next = section === 'chat' && !CHAT_NAV_ENABLED ? 'members' : section;
  try {
    localStorage.setItem('trainer_dashboard_active_section', next);
  } catch {
    // ignore
  }
}

/** Rail handler for trainer drill-down pages (workout detail, member detail, etc.). */
export function createTrainerDrillDownSectionSelect(navigate: NavigateFunction) {
  return (section: TrainerSection) => {
    persistTrainerDashboardSection(section);
    navigate('/trainer-dashboard');
  };
}

/** Map trainer-dashboard child paths to the rail highlight section. */
export function deriveTrainerActiveSectionFromPath(pathname: string): TrainerSection {
  if (pathname.includes('/member/')) return 'members';
  if (pathname.includes('/workout-plan/') || pathname.includes('/workout/')) return 'library';
  return 'members';
}
